import request from '@/utils/request'
import {baseUrl,} from "@/api/apiBase.js";
//获取用户详情
export function getNewsDetail(id) {
  return request({
    url: baseUrl + '/news/'+ id + '/detail',
    method: 'get'
  })
}
//获取用户角色列表
export function getUser_role(query) {
  return request({
    url: baseUrl + '/rbac/user_roles',
    method: 'get',
    params: query
  })
}
//获取角色对应菜单&操作列表
export function getUser_role_menus(query) {
  return request({
    url: baseUrl + '/rbac/user_role_menus',
    method: 'get',
    params: query
  })
}
/*启用/停用*/
export function getUserChangeStatus(id) {
  return request({
    url: baseUrl + '/user/' +  id + '/change_status',
    method: 'put',
  })
}
//重置密码
export function getUserResetPassword(id,data) {
  return request({
    url: baseUrl + '/user/' +  id + '/reset_password',
    method: 'post',
    data: data
  })
}
/*获取角色对应用户列表*/
export function getUserRoleUserList(id,query) {
  return request({
    url: baseUrl + '/user/role/' +  id + '/user_list',
    method: 'get',
    params: query
  })
}
//获取用户角色列表(审核)
export function getUserRoleList(query) {
  return request({
    url: baseUrl + '/user/role/list',
    method: 'get',
    params: query
  })
}




// 查询菜单列表
export function listMenu(query) {
  return request({
    url: '/system/menu/list',
    method: 'get',
    params: query
  })
}
// 新增菜单
export function addMenu(data) {
  return request({
    url: '/system/menu',
    method: 'post',
    data: data
  })
}
// 修改菜单
export function updateMenu(data) {
  return request({
    url: '/system/menu',
    method: 'put',
    data: data
  })
}

// 删除菜单
export function delMenu(menuId) {
  return request({
    url: '/system/menu/' + menuId,
    method: 'delete'
  })
}
